module.exports = __webpack_public_path__ + "static/img/shzImg.6c0999e9.png";